export default "__VITE_ASSET__Ca5vs0q___"